import { api } from '../api';

export const courseApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllModules: build.query({
      providesTags: ['modules', 'activities'],
      query: () => ({
        url: 'course-module',
      }),
    }),
    getCourseById: build.query({
      query: ({ id }) => ({
        url: `course/${id}`,
      }),
    }),
    getCourseStructure: build.query({
      query: () => ({
        url: 'course/structure',
      }),
    }),
    getCourses: build.query({
      providesTags: ['courses'],
      query: () => ({
        url: 'course',
      }),
    }),
    getLessonActivityById: build.query({
      query: ({ id }) => ({
        url: `lesson-activity/${id}`,
      }),
    }),
    getLessonById: build.query({
      query: ({ id }) => ({
        url: `lesson/${id}`,
      }),
    }),
    getModuleById: build.query({
      query: ({ id }) => ({
        url: `course-module/${id}`,
      }),
    }),
    getOfflineCourseModuleById: build.query({
      query: ({ id }) => ({
        url: `offline/course-module/${id}`,
      }),
    }),
  }),
  reducerPath: 'courseApi',
});
